@let isDarkMode =
  isManualDarkMode() || corporateDesignService.isDarkModeActive();
<div
  [ngClass]="{
    'opacity-60': ngControl.control!.disabled,
    'text-input-label bg-primary-off box-border flex w-full text-base':
      isDarkMode,
    'text-input-label bg-primary-on box-border flex w-full text-base':
      !isDarkMode,
  }"
  [ngStyle]="{
    backgroundColor: inputBackground(),
  }">
  @let hasError = ngControl.errors && ngControl.touched;

  <div class="relative flex w-full flex-row items-center bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      type="text"
      (change)="updateColorPickerValue()"
      (focus)="isFocused.set(true)"
      (blur)="isFocused.set(false)"
      [formControl]="ngControl.control! | toFormControl"
      class="border-input-ring border-input rounded-input p-input peer w-full bg-transparent pl-12! placeholder-transparent focus:ring-0"
      [ngClass]="{
        'border-input-error focus:border-input-focus': hasError,
        'border-input-ring focus:border-input-focus': !hasError,
        'cursor-not-allowed': ngControl.disabled,
      }"
      [ngStyle]="{
        borderRadius: borderRounding(),
        borderColor: borderAndLabelColor(),
        color: isDarkMode ? darkModeLabelColor() : '',
      }"
      [id]="id()" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 left-8 cursor-text bg-inherit text-sm transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [ngClass]="{ 'text-error-main': hasError }"
      [ngStyle]="{
        color: borderAndLabelColor(),
      }"
      [for]="id()"
      >{{ formattedLabel() }}</label
    >
    @if (!ngControl.control!.disabled) {
      <span
        class="material-symbols-rounded absolute right-2 cursor-pointer"
        [style.color]="isDarkMode ? darkModeLabelColor() : ''"
        (click)="openColorPicker()">
        colorize
      </span>
    }
    <input
      [ngClass]="{
        'pointer-events-none': ngControl.control!.disabled,
      }"
      class="border-input-ring absolute left-4 h-6 w-6 cursor-pointer border-1 focus:border-0"
      tabindex="-1"
      [attr.aria-label]="id() | appendTestId: 'picker'"
      [attr.data-testid]="id() | appendTestId: 'picker'"
      [cpDisabled]="ngControl.control!.disabled"
      [cpCancelButton]="true"
      [cpCancelButtonText]="'Abbrechen'"
      [cpOKButton]="true"
      [cpOKButtonText]="'Ok'"
      [defaultValue]="defaultColor"
      [cpOutputFormat]="'hex'"
      [cpAlphaChannel]="'disabled'"
      (cpToggleChange)="positionPicker($event)"
      (colorPickerSelect)="changeColor($event)"
      [(colorPicker)]="color"
      [style.background-color]="color" />
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
